export const groupEntriesByDate = <T>(
  entries: T[],
  fieldName: keyof T
): Record<string, T[]> => {
  return entries.reduce((groupedEntries, entry) => {
    const dateValue = entry[fieldName];

    if (typeof dateValue !== 'string') {
      return groupedEntries;
    }

    const dateOnly = dateValue.split('T')[0];

    if (!groupedEntries[dateOnly]) {
      groupedEntries[dateOnly] = [];
    }

    groupedEntries[dateOnly].push(entry);

    return groupedEntries;
  }, {} as { [date: string]: T[] });
};
